import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  ${theme.below.lg} {
    display: block;
  }
`;
const Column = styled('div')`
  flex: 1;
  width: 50%;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${theme.below.lg} {
    width: 100%;
    min-height: 300px;
  }

  img {
    max-width: 100%;
  }

  div.inner {
    padding: 40px;
    max-width: 580px;

    ${theme.below.lg} {
      padding: 30px;
    }

    h1 {
      font-size: 30px;
      line-height: 1.3;
      margin-bottom: 20px;
    }
    p {
      font-size: 13px;
    }
    a {
      color: ${theme.colors.primary};
      text-decoration: none;
      font-weight: 600;
    }
  }
`;
const ImageHolder = styled('div')`
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  ${theme.below.lg} {
    background-position: center;
    height: 300px;
  }
`;

const Intro = ({ image, children }) => (
  <Wrapper>
    <Column>
      <ImageHolder style={{ backgroundImage: `url(${image})` }} />
    </Column>

    <Column>
      <div className="inner">{children}</div>
    </Column>
  </Wrapper>
);

export default Intro;
